import { Routes, Route } from 'react-router-dom';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AboutUs from './components/about/AboutUs';
import BoardMembers from './components/board/BoardMembers';
import Community from './components/community/Community';
import CustomBreadcrumb from './components/home/CustomBreadcrumb';
import CommunityCenter from './components/community/sections/projects/CommunityCenter';
import EcoStp from './components/community/sections/projects/EcoStp';
import FAQ from './components/faq/FAQ';
import Footer from './layouts/footer/Footer';
import Gallery from './components/community/sections/gallery/Gallery';
import Greenary from './components/home/sections/greenary/Greenary';
import Header from './layouts/header/Header';
import HomePage from './components/home/HomePage';
import Maintenance from './components/community/sections/maintenance/Maintenance';
import NearbyLocality from './components/community/sections/locality/NearbyLocality';
import PageNotFound from './utils/PageNotFound';
import Projects from './components/community/sections/projects/Projects';
import RainWaterHarvest from './components/community/sections/projects/RainWaterHarvest';
import SolarSection from './components/community/sections/projects/SolarSection';
import Support from './components/support/Support';
import './App.css';

const App = () => {
  return (
    <div className="container-fluid app-container">
      <Header />
      <div className="container app-content px-0">
        <main className="row">
          <div className="col-12">
            <CustomBreadcrumb />
            <Routes>
              {/* Primary Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/board-members" element={<BoardMembers />} />

              {/* Community Routes */}
              <Route path="/community" element={<Community />} />
              <Route path="/maintenance" element={<Maintenance />} />
              <Route path="/projects" element={<Projects />} />
              <Route
                path="/projects/water-management"
                element={<RainWaterHarvest />}
              />
              <Route path="/projects/solar" element={<SolarSection />} />
              <Route path="/projects/ecostp" element={<EcoStp />} />
              <Route
                path="/projects/community-center"
                element={<CommunityCenter />}
              />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/nearby-locality" element={<NearbyLocality />} />
              <Route path="/greenary" element={<Greenary />} />

              {/* Additional Routes */}
              <Route path="/faq" element={<FAQ />} />
              <Route path="/support" element={<Support />} />

              {/* 404 Route */}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default App;
